import request from '@/utils/http/request'

/* 會員相關接口 */


//用戶登錄
export async function login({ username, password, openId }) {
    return await request.post('/auth/login', {
        phoneNumber: username,
        password,
        openId
    }, {
        noAuth: true
    });
}

//用戶註冊
export async function register({ name, gender, email, phoneNumber, code, password }) {
    return await request.post('/auth/register', {
        name, gender, email, phoneNumber, code, password
    }, {
        noAuth: true
    });
}

//發送驗證碼
export async function code({ businessType, phoneNumber }) {
    return await request.post('/auth/code', {
        businessType, phoneNumber
    }, {
        noAuth: false
    });
}

//刷新用戶token
export async function refresh(refreshToken) {
    return await request.post('/user/refresh', {
        refreshToken
    }, {
        noAuth: true
    });
}

//忘記密碼
export async function resetPwd({ code, phoneNumber, newPassword }) {
    return await request.post('/auth/resetPwd', {
        code, phoneNumber, newPassword
    });
}

//更新用戶資訊
export async function update_userinfo({ id, nickName }) {
    return await request.put('/user', {
        id,
        nickName
    });
}

//個人資訊
export async function members_profile() {
    return await request.post('/members/profile', {});
}


export async function edit_profile({
    name,
    birthDate,
    gender,
    email,
    phoneNumber,
    newPassword
}) {
    return await request.post('/members', {
        name,
        birthDate,
        gender,
        email,
        phoneNumber,
        newPassword
    });
}

/* 個人收藏 */
export async function members_favorites({ serviceType, pageNumber, pageSize }) {
    return await request.post(`/members/favorites`, {
        serviceType, pageNumber, pageSize
    });
}

/* 添加收藏 */
export async function members_favorites_insert({ serviceType, module, code }) {
    return await request.post(`/members/addFavorites`, {
        serviceType: serviceType || '', module, code
    });
}

/* 取消收藏 */
export async function members_favorites_cancel({ serviceType, module, code }) {
    return await request.post(`/members/remFavorites`, {
        serviceType: serviceType || '', module, code
    });
}




/* 發票相關 */
export async function members_invoice_list({ pageNumber, pageSize }) {
    return await request.post(`/member/invoice/invoiceList`, {
        pageNumber, pageSize
    });
}

/* 發票擡頭詳情 */
export async function members_invoice_detail(invoiceId) {
    return await request.post(`/member/invoice/detail`, { invoiceId });
}
/* 刪除發票擡頭信息 */
export async function members_invoice_del(invoiceId) {
    return await request.post(`/member/invoice/delete`, { invoiceId });
}
/* 新增發票擡頭 */
export async function members_invoice_insert({ invoiceTitle, invoiceType, invoiceEmail, invoiceTaxNo }) {
    return await request.post(`/member/invoice/add`, { invoiceTitle, invoiceType, invoiceEmail, invoiceTaxNo });
}
/* 更新發票擡頭 */
export async function members_invoice_update({ invoiceId, invoiceTitle, invoiceType, invoiceEmail, invoiceTaxNo }) {
    return await request.post(`/member/invoice/update`, { invoiceId, invoiceTitle, invoiceType, invoiceEmail, invoiceTaxNo });
}
/* 申請開發票接口 */
export async function members_invoice_apply({ rechargeOrderNoList, invoiceType, invoiceTaxNo, invoiceTitle, invoiceEmail, contactPhone }) {
    return await request.post(`/member/invoice/apply`, { rechargeOrderNoList, invoiceType, invoiceTaxNo, invoiceTitle, invoiceEmail, contactPhone });
}

/* 發票申請記錄接口 */
export async function members_invoice_invoiceApplyLog({ invoiceType, invoiceTitle, invoiceTaxNo, pageSize, pageNumber }) {
    return await request.post(`/member/invoice/invoiceApplyLog`, { invoiceType, invoiceTitle, invoiceTaxNo, pageSize, pageNumber });
}
/* 未開發票記錄列表接口 */
export async function members_invoice_uninvoiced({ pageSize, pageNumber }) {
    return await request.post(`/member/invoice/uninvoiced`, { pageSize, pageNumber });
}


export async function brand_activityList({ pageSize, pageNumber }) {
    return await request.post(`/home/brandActivityList`, { pageSize, pageNumber });
}

export async function brand_activity(id) {
    return await request.post(`/home/brandActivity`, { id });
}


export async function members_messages({ pageSize, pageNumber }) {
    return await request.post(`/members/messages`, { pageSize, pageNumber });
}

export async function members_messages_read(msgId) {
    return await request.post(`/members/messages/read`, { msgId });
}


export async function sysConfigs_stadiumConfig() {
    return await request.post(`/sysConfigs/stadiumConfig`, {}, {
        noAuth: true
    });
}


/* 賬號註銷 */
export async function members_cancel() {
    return await request.post(`/members/cancel`, {});
}



export async function auth_line_login({ code, redirectUri }) {
    return await request.post(`/auth/line/login`, { code, redirectUri });
}

export async function auth_line_authorize() {
    return await request.post(`/auth/line/authorize`, {});
}